// extracted by mini-css-extract-plugin
module.exports = {"carousel":"scss_carousel__3T62k","featured-products":"scss_featured-products__1HATh","slide":"scss_slide__1B2hv","sticky-ball":"scss_sticky-ball__1LGa5"};